export function getPositiveFiniteNumber(value: unknown): number | undefined {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) && numberValue > 0
    ? numberValue
    : undefined;
}

export function getDensityWeightUnitId(weightUnit: unknown): number {
  return String(weightUnit ?? 'lbs').toLowerCase() === 'kg' ? 0 : 1;
}

export function getDensityDimensionUnitId(dimensionUnit: unknown): number {
  return ['ft', 'feet', 'foot'].includes(
    String(dimensionUnit ?? 'inches').toLowerCase()
  )
    ? 1
    : 0;
}

export function calculateCubicFeet({
  length,
  width,
  height,
  handlingQuantity,
  dimensionUnitId,
}: {
  length: unknown;
  width: unknown;
  height: unknown;
  handlingQuantity: unknown;
  dimensionUnitId: number;
}): number {
  const parsedLength = getPositiveFiniteNumber(length);
  const parsedWidth = getPositiveFiniteNumber(width);
  const parsedHeight = getPositiveFiniteNumber(height);

  if (!parsedLength || !parsedWidth || !parsedHeight) {
    return 0;
  }

  const effectiveHandlingQuantity =
    getPositiveFiniteNumber(handlingQuantity) ?? 1;
  const volume =
    dimensionUnitId === 0
      ? (parsedLength * parsedWidth * parsedHeight) / 1728
      : parsedLength * parsedWidth * parsedHeight;

  return volume * effectiveHandlingQuantity;
}

export function buildItemDimensionsKey({
  length,
  width,
  height,
  weight,
  handlingQuantity,
  weightUnit,
  dimensionUnit,
}: {
  length: unknown;
  width: unknown;
  height: unknown;
  weight: unknown;
  handlingQuantity: unknown;
  weightUnit: unknown;
  dimensionUnit: unknown;
}): string {
  return [
    String(length ?? ''),
    String(width ?? ''),
    String(height ?? ''),
    String(weight ?? ''),
    String(handlingQuantity ?? ''),
    String(getDensityWeightUnitId(weightUnit)),
    String(getDensityDimensionUnitId(dimensionUnit)),
  ].join('|');
}
